<template>
    <div class="overflow-hidden">
        <div class="pdp-image-container lg:grid lg:grid-cols-2 lg:gap-6">
            <ShopwareProductDetailImageSlider :product="product.product" />
            <div class="normal-container relative p-5 px-0 lg:p-8 lg:pt-6 lg:pr-0 xl:p-[66px] xl:pt-6 xl:pr-0">
                <div class="absolute top-0 -left-[20px] -z-10 h-full w-screen bg-green-300 lg:left-0"></div>

                <ShopwareProductDetailMain
                    :product="product.product"
                    :variants="product.configurator"
                    :colorVariants="colorVariants" />
            </div>
        </div>

        <div class="flex flex-col-reverse lg:flex-col">
            <ShopwareProductDetailBrandHighlight
                :product="product.product"
                :brandRecommendations="brandRecommendations" />
            <TweakwiseRecommendations :products="recommendations" />
        </div>
    </div>
</template>

<script lang="ts" setup>
    const { $tweakwise } = useNuxtApp();
    const props = defineProps<{
        product?: any;
        colorVariants?: any[];
        recommendations?: any[];
        brandRecommendations?: any[];
    }>();

    useProductSchema({
        product: () => props.product?.product,
        variants: () => props.product?.configurator,
        breadcrumbs: inject('breadcrumbs', []) as any[],
    });

    onMounted(() => {
        $tweakwise.trackProductView(props.product.product.id);
    });
</script>
